import { configureStore } from "@reduxjs/toolkit";
import generateEmailLinkReducer from "../features/Api/generateEmailLinkSlice";
import EmailVerificationReducer from "../features/EmailVerificationSlice";
import DarkModeTogglerReducer from "../features/DarkModeTogglerSlice";
import UserReducer from "../features/UserLoginStatusSlice";
import ViewStyleBtnCollectionReducer from "../features/LoggedInComponents/ViewStyleBtnCollectionSlice";
import SetDisplayCollectionMyQueryOrDocumentReducer from "../features/LoggedInComponents/SetDisplayCollectionMyQueryOrDocumentSlice";
import generateLoginRequestReducer from "../features/Api/loginSlice";
import loadingBarReducer from "../features/LoadingBarSlice";
import fetchUserProfileReducer from "../features/Api/userProfile";
import DisplayAlertRefreshInValidReducer from "../features/DisplayAlertRefreshInValidSlice";
import patchForProfileInfoSlice from "../features/Api/patchForProfileInfoSlice";
import updateEmail_Generate_OTP_Reducer from "../features/Api/getOTP_ForUpdateUserEmail";
import updateEmail_Verify_OTP_Reducer from "../features/Api/verifyOTP_ForUpdateUserEmail";
import change_ApiKey_Reducer from "../features/Api/changeApiKeySlice";
import removeLoginUserAccess_Reduce from "../features/Api/removeLoginDevicesAccess";
import change_Password_Reducer from "../features/Api/changePasswordSlice";
import subscribe_Email_Update_Reducer from "../features/Api/subscribe_To_Email_Updates";
import submit_User_feedback_Reducer from "../features/Api/submitUserFeedback";
import contact_Us_Form_Reducer from "../features/Api/contactUsForm";
import dbListSlice_Reducer from "../features/Api/databaseListSlice";
import getDataBaseListWithCollection_Reducer from "../features/Api/Dashboard/getDataBaseList";
import databaseListGlobalReducer from "../features/Dashboard/databaseListGlobalSlice";
import createNewDb_Reducer from "../features/Api/createDataBaseSlice";

export default configureStore({
  reducer: {
    subscribe_Email_Update: subscribe_Email_Update_Reducer,
    signUp: generateEmailLinkReducer,
    logIn: generateLoginRequestReducer,
    userProfileInfo: fetchUserProfileReducer,
    patchProfileInfoData: patchForProfileInfoSlice,
    loadingBarProgress: loadingBarReducer,
    emailVerification: EmailVerificationReducer,
    setMode: DarkModeTogglerReducer,
    user: UserReducer,
    setDisplayIfBoxStyleCollection: ViewStyleBtnCollectionReducer,
    SetDisplayCollectionMyQueryOrDocument:
      SetDisplayCollectionMyQueryOrDocumentReducer,
    DisplayRefreshTokenAlert: DisplayAlertRefreshInValidReducer,
    updateEmail_Generate_OTP: updateEmail_Generate_OTP_Reducer,
    updateEmail_Verify_OTP: updateEmail_Verify_OTP_Reducer,
    changeApi_key: change_ApiKey_Reducer,
    removeLoginUserAccess: removeLoginUserAccess_Reduce,
    changePassword: change_Password_Reducer,
    submitUserFeedback: submit_User_feedback_Reducer,
    contactUsForm: contact_Us_Form_Reducer,
    createNewDb: createNewDb_Reducer,
    dbList: dbListSlice_Reducer,
    dbListWithCollection: getDataBaseListWithCollection_Reducer,
    databaseListGlobalState: databaseListGlobalReducer,
    new_db_crete: createNewDb_Reducer,
  },
});
